import React, { useState, useRef, useEffect } from "react";
import { Box, Input, Checkbox, Text, InputGroup, InputRightElement, Collapse, VStack, IconButton, FormControl, FormLabel, FormErrorMessage, InputLeftElement, Button, } from "@chakra-ui/react";
import { BorderedTick, ChevronDownIcon, ChevronUp, LocationIcon } from "../../../Assets/images/svgs";

const AutoCompleteMultiSelect = ({ options = [], inputName, autoFillOptions = [], placeholder, onChange, maxHeight = "360px", label = "", isRequired = false, errMessage = "", icon, showCheckboxes, handleFilterApply, showListControls }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const ref = useRef();

  const handleSelect = (option) => {
    const updatedSelectedOptions = selectedOptions.some(
      (item) => item.value === option.value
    )
      ? selectedOptions.filter((item) => item.value !== option.value)
      : [...selectedOptions, option];
    setSelectedOptions(updatedSelectedOptions);
    if (onChange) {
      onChange(updatedSelectedOptions);
    }
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (autoFillOptions.length) {
      setSelectedOptions(autoFillOptions);
    }
  }, [autoFillOptions]);

  const handleApply = () => {
    if (selectedOptions.length) setIsOpen(false);
    handleFilterApply(selectedOptions, selectedOptions.length === options.length);
  }

  return (
    <FormControl
      isInvalid={errMessage}
      isRequired={isRequired}
      className={"multi-select-form-control"}
    >
      {label && <FormLabel className={"multi-select-label"}>{label}</FormLabel>}
      <Box position="relative" ref={ref} className="input-box">
        <InputGroup>
          {icon ? <InputLeftElement pointerEvents='none'>
            {icon}
          </InputLeftElement> : null}
          <Input
            value={selectedOptions.length === options.length ? placeholder : selectedOptions.length ? `${selectedOptions.length} Selected` : placeholder}
            readOnly
            onClick={handleToggle}
            cursor="pointer"
            pr="40px"
            className={`custom-input outer-input`}
            name={inputName}
            type="text"
          />
          <InputRightElement>
            <IconButton
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              icon={isOpen ? <ChevronUp /> : <ChevronDownIcon />}
              aria-label={isOpen ? "Collapse" : "Expand"}
              onClick={handleToggle}
              variant="unstyled"
              size="sm"
              _focus={{ boxShadow: "none" }}
              className="custom-icon-button"
            />
          </InputRightElement>
        </InputGroup>
        <Collapse
          in={isOpen}
          style={{ position: "absolute", zIndex: 10, width: "100%" }}
        >
          <Box
            borderWidth="1px"
            borderRadius="md"
            mt="2"
            p="2"
            bg="white"
            shadow="md"
            maxHeight={maxHeight}
            overflowY="auto"
            className="dropdown-list"
          >
            {showListControls ? <div className="dropdown-list-controls">
              <div>
                <Button className="select-all-button" onClick={() => setSelectedOptions(options)}>Select All</Button>
                <Button className="clear-all-button" onClick={() => setSelectedOptions([])}>Clear All</Button>
              </div>
              <Button className={`apply-filtered-dropdown-btn ${!selectedOptions.length ? "disabled-btn" : ""}`} disabled={!selectedOptions.length} onClick={handleApply} >Apply</Button>
            </div> : null}
            <Input
              placeholder="Search..."
              mb="2"
              value={searchTerm}
              onChange={handleSearch}
              className="custom-input"
              id="search"
            />
            <VStack align="start" spacing="1">
              {filteredOptions.length === 0 ? (
                <Text>No options found</Text>
              ) : (
                filteredOptions.map((option) => {
                  if (showCheckboxes) return (
                    <Box key={option.value} width="100%">
                      <Checkbox isChecked={selectedOptions.some( (selected) => selected.value === option.value )} onChange={() => handleSelect(option)}>
                        {option.label}
                      </Checkbox>
                    </Box>
                  )

                  const isOptionSelected = selectedOptions.some((selected) => selected.value === option.value);

                  return (
                    <Box key={option.value} width="100%" className={`option-box ${isOptionSelected ? "selected-option" : ""}`} onClick={() => handleSelect(option)}>
                      {option.label}
                      {isOptionSelected ? <BorderedTick /> : null}
                    </Box>
                  )
                })
              )}
            </VStack>
          </Box>
        </Collapse>
        {errMessage && <FormErrorMessage>{errMessage}</FormErrorMessage>}
      </Box>
    </FormControl>
  );
};
export default AutoCompleteMultiSelect;
